/**
 * @generated SignedSource<<e949a821a997fc5396b120ce6115eccf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditObjectiveDeleteMutation$variables = {
  objectiveId: string;
};
export type EditObjectiveDeleteMutation$data = {
  readonly Objective_Delete: {
    readonly ok: boolean;
  } | null;
};
export type EditObjectiveDeleteMutation = {
  response: EditObjectiveDeleteMutation$data;
  variables: EditObjectiveDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "objectiveId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "objectiveId",
        "variableName": "objectiveId"
      }
    ],
    "concreteType": "DeleteObjective",
    "kind": "LinkedField",
    "name": "Objective_Delete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditObjectiveDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditObjectiveDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7cc9cb31121ec5c2a55f451a368c7ba8",
    "id": null,
    "metadata": {},
    "name": "EditObjectiveDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation EditObjectiveDeleteMutation(\n  $objectiveId: ID!\n) {\n  Objective_Delete(objectiveId: $objectiveId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "05532e25fd5f429986b3fdc2fcb95964";

export default node;
